<template>
  <div id="app" class="app">
    <Header />
    <router-view/>
    <footer>
      <cookie-banner />
    </footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import CookieBanner from '@/components/CookieBanner.vue'

export default {
  components: {
    Header,
    CookieBanner
  }
}
</script>

<style lang="postcss">
@import url(~@/assets/custom-properties.css);

html,body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

.app {
  font-family: var(--default-font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  display: flex;
  flex-direction: column;
  color: var(--text-color);
  text-shadow: 0.5px 0.5px 1px rgba(0,0,0,0.2);
  max-width: 1200px;
  margin: 0 auto;
}
</style>
